import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

import { UserProvider } from '../../providers/user';

import { Settings } from '../../settings';

/**
 * Generated class for the WorkplanDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-workplan-details',
  templateUrl: 'workplan-details.html',
})
export class WorkplanDetailsPage {

  plan: any;
  projectManagerName: string = Settings.projectManagerName;

  projectCreatorName: string = Settings.projectCreatorName;
  showProjectCreator = Settings.showProjectCreator;

  showJobTitle = Settings.showJobTitle;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public viewCtrl: ViewController) {
    this.plan = this.navParams.get('data');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WorkplanDetailsPage');
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/workplan-details/workplan-details.ts